"use client";
import { useDispatch } from "react-redux";
import { setHamburgerState } from "@/store";
import { Button } from "../Global/Button";
import { Bars3Icon } from "@heroicons/react/24/outline";

export const MobileMenu = () => {
  const dispatch = useDispatch();

  const onOpenHandler = () => {
    dispatch(setHamburgerState(true));
  };
  return (
    <div className="flex xl:hidden">
      <Button
        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
        func={onOpenHandler}
      >
        <span className="sr-only">Open main menu</span>
        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
      </Button>
    </div>
  );
};
